import { styled } from '@mui/material/styles';
import React from 'react';

const PREFIX = 'DiamondDigitalLogo';

const classes = {
  container: `${PREFIX}-container`,
  logo: `${PREFIX}-logo`,
};

const Root = styled('div')({
  [`&.${classes.container}`]: {
    position: 'relative',
  },
  [`& .${classes.logo}`]: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translateY(-38%) translateX(-60%)',
  },
});

const Logo = ({ width, height, maxWidth, logo }) => {
  return (
    <Root
      className={classes.container}
      style={{ width: width, height: height }}
    >
      <div
        className={classes.logo}
        style={{ maxWidth: maxWidth, width: width }}
      >
        <img src={logo} alt="logo" />
      </div>
    </Root>
  );
};

export default Logo;
